import { html, LitElement } from 'lit';
import { state } from 'lit/decorators.js';
import './ix-generic-tree.js';
import testData from './test/test-data.js';

export class IxGenericTreeDemo extends LitElement {
  @state() searchEnabled = true;

  @state() showCheckboxes = true;

  @state() filledIcons = true;

  private toggleSearch() {
    this.searchEnabled = !this.searchEnabled;
  }

  private toggleCheckboxes() {
    this.showCheckboxes = !this.showCheckboxes;
  }

  private toggleIcons() {
    this.filledIcons = !this.filledIcons;
  }

  render() {
    return html`
      <div>
        <button @click=${this.toggleSearch}>
          Search: ${this.searchEnabled ? 'On' : 'Off'}
        </button>
        <button @click=${this.toggleCheckboxes}>
          Checkboxes: ${this.showCheckboxes ? 'On' : 'Off'}
        </button>
        <button @click=${this.toggleIcons}>
          Filled icons: ${this.filledIcons ? 'On' : 'Off'}
        </button>
        <ix-generic-tree
          .rootNode=${testData}
          ?searchEnabled=${this.searchEnabled}
          ?showCheckboxes=${this.showCheckboxes}
          ?filledIcons=${this.filledIcons}
          searchPlaceholder="placeholder"
          .selectedId=${testData.children![0].id}
        ></ix-generic-tree>
      </div>
    `;
  }
}
